@if ({
  customers: dashboard$ | async,
  isMobile: isMobile$ | async,
  dashboardSelection: dashboardSelection$ | async
  }; as colorDashboard) {
  <mat-card
    appearance="outlined"
    class="dashboard-card padding-16"
    >
    <colimo-page-header [heading]="heading"> </colimo-page-header>
    <div class="flex-column gap-25">
      @for (customer of colorDashboard.customers; track customer.customer) {
        <mat-expansion-panel
          [expanded]="colorDashboard.dashboardSelection.customer === customer.customer"
          >
          <mat-expansion-panel-header
            class="flex-row align-start"
            [ngClass]="colorDashboard.isMobile.isMobile === true ? 'mobile-panel-header' : ''"
            (click)="customerSelected(customer.customer, colorDashboard.dashboardSelection.customer)"
            >
            <mat-panel-title class="flex-grow-0">
              <colimo-customer-cards
                class="flex-row gap-35 gap-lt-sm-0 start-center"
                [customer]="customer"
              ></colimo-customer-cards>
            </mat-panel-title>
            <mat-panel-description class="customer-panel flex-row spacebetween-center">
              @if (!colorDashboard.isMobile.isMobile) {
                <div class="flex-90 pipe-list">
                  {{ customer.sites | arrayToPipeList: 'siteName' }}
                </div>
              }
              <div class="flex-column flex-100px spacebetween-end flex-lt-sm-100">
                <div class="flex-row center-end bell-wrapper">
                  @if (alertsConfigured) {
                    <mat-icon class="bell-format"> notification_important </mat-icon>
                  }
                  @if (!alertsConfigured) {
                    <mat-icon class="bell-format"> notifications_off </mat-icon>
                  }
                  @if (alertsConfigured) {
                    <div
                      class="notification-badge"
                      [ngClass]="(customer.projects | warningsCount) !== 0 ? ((customer.projects | alertMaxLevel) >= 2000 ? 'red-bell' : 'yellow-bell') : 'green-bell'"
                      >
                      {{ customer.projects | warningsCount }}
                    </div>
                  }
                </div>
                <div class="flex-row end-end gap-10 product-count-container">
                  <span class="product-count"
                    >{{ customer.projects | productCount }} {{ 'dashboard.products' | translate }}
                  </span>
                </div>
              </div>
            </mat-panel-description>
          </mat-expansion-panel-header>
          <ng-template matExpansionPanelContent>
            <div class="flex-row flex-wrap column-gap-20 gap-lt-sm-0"
              [ngClass]="colorDashboard.isMobile.isMobile === true ? 'mobile-panel-content' : ''">
              @for (project of customer.projects; track project.id) {
                <colimo-color-card
                  class="color-card"
                  [ngClass]="colorDashboard.isMobile.isMobile === true ? 'mobile-color-card' : ''"
                  [project]="project"
                  [routerLink]="['/project/', project.id, 'color', 'page', 0]"
                  (click)="colorCardSelected(project)"
                ></colimo-color-card>
              }
            </div>
          </ng-template>
        </mat-expansion-panel>
      }
    </div>
  </mat-card>
}

@if (isLoading) {
  <colimo-loader [background]="'transparent'" [top]="'50%'"></colimo-loader>
}
